import { HttpInterceptorFn } from '@angular/common/http';
import { timeout } from 'rxjs';

const DEFAULT_TIMEOUT_MS = 30_000;
const DOWNLOAD_TIMEOUT_MS = 60_000;

export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
  const ms =
    req.responseType === 'blob' || req.responseType === 'arraybuffer'
      ? DOWNLOAD_TIMEOUT_MS
      : DEFAULT_TIMEOUT_MS;

  return next(req).pipe(timeout(ms));
};
